import API from "../../Api";
import { tinyURLRequest } from "./tinyURLModels";

export async function getActualURLAPI(details: tinyURLRequest) {
  return API({
    method: "POST",
    url: "/api/customers/delivery/getActualURL",
    data: details,
  });
}
